import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function TickIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 21 21">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.1797 0H3C1.34315 0 0 1.34315 0 3V18C0 19.6569 1.34315 21 3 21H18C19.6569 21 21 19.6569 21 18V3C21 2.17179 20.6644 1.42197 20.1217 0.879108L11.3571 16.726C11.0797 17.2274 10.5409 17.527 9.96865 17.4981C9.39636 17.4691 8.89057 17.1167 8.66526 16.5898L4.62082 7.13216C4.29508 6.37046 4.64851 5.48892 5.41021 5.16319C6.17191 4.83746 7.05345 5.19088 7.37918 5.95258L10.217 12.5887L17.1797 0Z" fill="#292929"/>
    </SvgIcon>
  );
}